"use client";


import {useAuthentication} from "@/state/Authentication";
import { ApolloClient, HttpLink, InMemoryCache, ApolloLink } from "@apollo/client";


const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    let token = useAuthentication.getState().token;

    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }));

    return forward(operation);
})


// const activityMiddleware = new ApolloLink((operation, forward) => {
//     // add the recent-activity custom header to the headers
//
//     console.log(operation);
//
//     return forward(operation);
// })

// const activityMiddleware = new ApolloLink((operation, forward) => {
//     return forward(operation).map(response => {

//         if(response?.errors)
//         {
//             (response?.errors?.map( (row) => {
//                 if(row.message.includes("not authorized"))
//                 {
//                     eventBus.next({type: AuthorizationCheckRequired})
//                 }
//             }));
//         }



//         return response;
//     });
// });


// const resetToken = onError(({ response, networkError }, cb) => {
//     if (networkError && networkError.statusCode === 401) {
//         // remove cached token on 401 from the server
//         //eventBus.next({type: AuthorizationCheckRequired})
//         // pass something back to apollo
//         cb({ data: response.data });
//     }
// });



function GetApiUrl()
{
    let url;



    if(typeof window !== "undefined" && window.location.hostname == "localhost")
    {
        url = "https://rentalflow.dwai.xyz/api/graphql/";
    }
    else if(typeof window !== "undefined" && window.location.hostname == "rentalflow.dwai.xyz")
    {
        url = "https://rentalflow.dwai.xyz/api/graphql/";
    }
    else if(typeof window !== "undefined" && window.location.hostname == "rentalflow.ai")
    {
        url = "https://api.rentalflow.ai/api/graphql/";
    }
    return url;
}





// const httpLink = createHttpLink({
//     uri: GetApiUrl(),
// });

//  const client_old = new ApolloClient({
//     // link:  authFlowLink.concat(httpLink), // Replace with your GraphQL endpoint
//     link: from([
//         authMiddleware,
//         // activityMiddleware,
//         httpLink,
//         // resetToken
//     ]),
//     cache: new InMemoryCache(),
// });





export const client = new ApolloClient({
    link: authMiddleware.concat(new HttpLink({ uri: GetApiUrl() })),

    cache: new InMemoryCache(),
  });